<template>
  <div :style="containerStyles">
    <!-- Header Skeleton -->
    <div :style="headerStyles">
      <div :style="headerContentStyles">
        <!-- Back button skeleton -->
        <div :style="{ ...circleStyles, width: '24px', height: '24px' }"></div>
        
        <!-- Title skeleton -->
        <div :style="{ ...lineStyles, height: '20px', width: '96px' }"></div>
        
        <!-- Expand button skeleton -->
        <div :style="{ ...circleStyles, width: '24px', height: '24px' }"></div>
      </div>
    </div>
    
    <!-- Simple Content Skeleton -->
    <div :style="contentStyles">
      <!-- FAQ Title Skeleton -->
      <div :style="{ ...lineStyles, height: '32px', width: '70%', marginBottom: '20px' }"></div>
      
      <!-- Excerpt Skeleton -->
      <div :style="{ ...lineStyles, height: '16px', width: '90%', marginBottom: '20px' }"></div>
      
      <!-- Content Line Skeleton -->
      <div :style="{ ...lineStyles, height: '16px', width: '75%' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQDetailSkeleton',
  props: {
    animated: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      shimmerStep: 0,
      animationInterval: null
    };
  },
  computed: {
    containerStyles() {
      return {
        height: '100%',
        minHeight: '100%',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column'
      };
    },

    headerStyles() {
      return {
        padding: '12px 16px',
        backgroundColor: '#ffffff',
        position: 'sticky',
        top: '0',
        zIndex: '10',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
      };
    },

    headerContentStyles() {
      return {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      };
    },

    contentStyles() {
      return {
        flex: '1',
        overflowY: 'auto',
        padding: '16px'
      };
    },

    baseSkeletonStyles() {
      return {
        background: this.animated ? this.getShimmerBackground() : 'oklch(95% 0 0)',
        borderRadius: '4px'
      };
    },

    lineStyles() {
      return {
        ...this.baseSkeletonStyles
      };
    },

    circleStyles() {
      return {
        ...this.baseSkeletonStyles,
        borderRadius: '50%'
      };
    },

    rectStyles() {
      return {
        ...this.baseSkeletonStyles,
        borderRadius: '8px'
      };
    }
  },
  mounted() {
    if (this.animated) {
      this.startShimmerAnimation();
    }
  },
  beforeUnmount() {
    this.stopShimmerAnimation();
  },
  methods: {
    getShimmerBackground() {
      if (!this.animated) return 'oklch(95% 0 0)';
      
      // Calculate shimmer position based on animation step
      const position = (this.shimmerStep % 200) - 100; // -100 to 100
      
      return `linear-gradient(90deg, 
        oklch(95% 0 0) ${position - 50}%, 
        oklch(92% 0 0) ${position}%, 
        oklch(95% 0 0) ${position + 50}%)`;
    },

    startShimmerAnimation() {
      if (this.animationInterval) return;
      
      this.animationInterval = setInterval(() => {
        this.shimmerStep += 2; // Increment for smooth movement
        this.$forceUpdate(); // Force re-render to update shimmer
      }, 50); // Update every 50ms for smooth animation
    },

    stopShimmerAnimation() {
      if (this.animationInterval) {
        clearInterval(this.animationInterval);
        this.animationInterval = null;
      }
    }
  }
};
</script>